// extracted by mini-css-extract-plugin
export default {"header":"Header__header--3v-","name":"Header__name--k1I","closeIcon":"Header__closeIcon--1Mc","backIconContainer":"Header__backIconContainer--3cd","backIcon":"Header__backIcon--3LI"};